"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibilityDelayToMs = exports.TaskKindConfigSchema = exports.PriorityThresholdsSchema = exports.durationToSeconds = exports.VisibilityDelaySchema = exports.DurationSchema = exports.EventBindingSchema = void 0;
const zod_1 = require("zod");
const event_names_1 = require("./event-names");
const eventNameSchema = zod_1.z.custom((value) => typeof value === 'string' && event_names_1.EVENT_NAMES_TUPLE.includes(value), { message: 'Unknown event name' });
exports.EventBindingSchema = zod_1.z.object({
    event: eventNameSchema,
    predicateId: zod_1.z.string().min(1).optional(),
});
exports.DurationSchema = zod_1.z.object({
    days: zod_1.z.number().int().nonnegative().optional(),
    hours: zod_1.z.number().int().nonnegative().optional(),
    minutes: zod_1.z.number().int().nonnegative().optional(),
    seconds: zod_1.z.number().int().nonnegative().optional(),
});
// Legacy alias kept for existing imports. `VisibilityDelay` is the same shape as `Duration`.
exports.VisibilityDelaySchema = exports.DurationSchema;
const durationToSeconds = (d) => {
    const days = d.days ?? 0;
    const hours = d.hours ?? 0;
    const minutes = d.minutes ?? 0;
    const seconds = d.seconds ?? 0;
    return ((days * 24 + hours) * 60 + minutes) * 60 + seconds;
};
exports.durationToSeconds = durationToSeconds;
exports.PriorityThresholdsSchema = zod_1.z
    .object({
    urgent: exports.DurationSchema,
    week: exports.DurationSchema,
    later: exports.DurationSchema,
})
    .refine(({ urgent, week, later }) => (0, exports.durationToSeconds)(urgent) <= (0, exports.durationToSeconds)(week) &&
    (0, exports.durationToSeconds)(week) <= (0, exports.durationToSeconds)(later), { message: 'priorityThresholds must be monotonically non-decreasing (urgent ≤ week ≤ later)' });
const ICON_IDS = [
    'send',
    'alert',
    'clock',
    'check',
    'eye',
    'flag',
    'phone',
    'pushpin',
    'warning',
    'info',
];
const iconIdSchema = zod_1.z.enum(ICON_IDS);
exports.TaskKindConfigSchema = zod_1.z.object({
    kind: zod_1.z.string().min(1),
    displayName: zod_1.z.string().min(1),
    icon: iconIdSchema,
    accentColor: zod_1.z.string().min(1),
    accentBg: zod_1.z.string().min(1),
    actionLabel: zod_1.z.string().min(1),
    handlerId: zod_1.z.string().min(1),
    description: zod_1.z.string().optional(),
    visibilityDelay: exports.DurationSchema,
    targetDelay: exports.DurationSchema,
    priorityThresholds: exports.PriorityThresholdsSchema,
    createOn: zod_1.z.array(exports.EventBindingSchema),
    deleteOn: zod_1.z.array(exports.EventBindingSchema),
});
const visibilityDelayToMs = (delay) => (0, exports.durationToSeconds)(delay) * 1000;
exports.visibilityDelayToMs = visibilityDelayToMs;
//# sourceMappingURL=task-kind-config.schema.js.map